module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cb0b3132e926a32505fbd25af018203c.png";